export class BranchReference {
    constructor(assetId, hierarchyId) {
        this.assetId = assetId;
        this.hierarchyId = hierarchyId;
        this.key = this.hierarchyId + (assetId || '');
    }
}
